var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"Vlt-title--icon"},[_c('vlt-icon',{attrs:{"color":_vm.color || _vm.iconColor,"icon":_vm.icon}}),_vm._v(_vm._s(_vm.title)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }